package com.upcominds.expedite.data.auth

import kotlinx.datetime.Clock

fun nowEpochSeconds(): Long = Clock.System.now().epochSeconds
